"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/label-has-associated-control */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const UI_1 = require("~/components/UI");
const passwordPolicy_1 = require("~/consts/passwordPolicy");
const react_helmet_async_1 = require("react-helmet-async");
const AuthorizationForm_module_scss_1 = __importDefault(require("../../AuthorizationForms/AuthorizationForm.module.scss"));
function NewPassword({ onSubmit }) {
    const { t } = (0, react_i18next_1.useTranslation)('authorization');
    const [password, setPassword] = (0, react_1.useState)({
        value: '',
        error: null,
    });
    return (react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.container },
        react_1.default.createElement(react_helmet_async_1.Helmet, null,
            react_1.default.createElement("title", null, "Restore Password | TBUILD")),
        react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.headline },
            t('headline.new-password.main'),
            react_1.default.createElement("div", null, t('headline.new-password.subtitle'))),
        react_1.default.createElement("form", null,
            react_1.default.createElement("label", null,
                " ",
                t('password.title')),
            react_1.default.createElement(UI_1.Input, { type: "password", maxLength: passwordPolicy_1.PASSWORD_MAX_LENGTH, placeholder: t('password.placeholder'), value: password.value, onChange: (value, error) => {
                    setPassword({ value, error });
                }, onInput: (value, error) => {
                    setPassword({ value, error });
                }, required: true, minLength: passwordPolicy_1.PASSWORD_MIN_LENGTH, customErrors: { 'required': t('password.error.required'), 'min-value': t('password.error.min-value'), 'max-value': t('password.error.max-value') } }),
            react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.footer },
                react_1.default.createElement(UI_1.Button, { wide: true, variant: "primary", onClick: (event) => {
                        event.preventDefault();
                        onSubmit(password.value);
                    }, disabled: Boolean(password.error) ||
                        password.value.trim().length < passwordPolicy_1.PASSWORD_MIN_LENGTH ||
                        password.value.trim().length > passwordPolicy_1.PASSWORD_MAX_LENGTH }, t('button.save-n-sign-in'))))));
}
exports.default = NewPassword;
